export const ChartFormatterTypes = Object.freeze({
    NO_FORMATTER: "no-formatter",
    EURO_NO_DECIMALS: "euro-no-decimals",
    EURO_TWO_DECIMALS: "euro-two-decimals",
    PERCENT_NO_DECIMALS: "percent-no-decimals",
    PERCENT_TWO_DECIMALS: "percent-two-decimals",
    NUMBER_NO_DECIMALS: "number-no-decimals",
    NUMBER_TWO_DECIMALS: "number-two-decimals",
})

const chartFormatterOptions = [
    {
        value: ChartFormatterTypes.NO_FORMATTER,
        label: "Nicht formatieren",
    },
    {
        value: ChartFormatterTypes.EURO_NO_DECIMALS,
        label: "Euro, keine Nachkommastellen",
    },
    {
        value: ChartFormatterTypes.EURO_TWO_DECIMALS,
        label: "Euro, zwei Nachkommastellen",
    },
    {
        value: ChartFormatterTypes.PERCENT_NO_DECIMALS,
        label: "Prozent, keine Nachkommastellen",
    },
    {
        value: ChartFormatterTypes.PERCENT_TWO_DECIMALS,
        label: "Prozent, zwei Nachkommastellen",
    },
    {
        value: ChartFormatterTypes.NUMBER_NO_DECIMALS,
        label: "Nummer, keine Nachkommastellen",
    },
    {
        value: ChartFormatterTypes.NUMBER_TWO_DECIMALS,
        label: "Nummer, zwei Nachkommastellen",
    },
]

export const barChartPrototypes = Object.freeze({
    xTicksDisplay: {
        "key": "xTicksDisplay",
        "type": "YESNO",
        "label": "X Ticks anzeigen",
        "size": 6,
    },
    yTicksDisplay: {
        "key": "yTicksDisplay",
        "type": "YESNO",
        "label": "Y Ticks anzeigen",
        "size": 6,
    },
    xGridDisplay: {
        "key": "xGridDisplay",
        "type": "YESNO",
        "label": "X Grid anzeigen",
        "size": 6,
    },
    yGridDisplay: {
        "key": "yGridDisplay",
        "type": "YESNO",
        "label": "Y Grid anzeigen",
        "size": 6,
    },
    titlesTicksDisplay: {
        "key": "titlesTicksDisplay",
        "type": "YESNO",
        "label": "Title Ticks anzeigen",
        "size": 6,
    },
    yAxisFormatter: {
        key: "yAxisFormatter",
        type: "SELECT",
        label: "Y Achsen Formatter",
        size: 6,
        options: chartFormatterOptions,
    },
    barPercentage: {
        "key": "barPercentage",
        "type": "INTEGER",
        "label": "Balkenbreite in %",
        "size": 6,
    },
    maxBarThickness: {
        "key": "maxBarThickness",
        "type": "INTEGER",
        "label": "Maximale Balkenbreite in Px",
        "size": 6,
    },
    tooltipFormatter: {
        key: "tooltipFormatter",
        type: "SELECT",
        label: "Tooltip Formatter",
        size: 6,
        options: chartFormatterOptions,
    },
})

export const barChartPrototypesDefaults = Object.freeze({
    xTicksDisplay: false,
    yTicksDisplay: false,
    xGridDisplay: false,
    yGridDisplay: false,
    titlesTicksDisplay: false,
    yAxisFormatter: ChartFormatterTypes.NO_FORMATTER,
    tooltipFormatter: ChartFormatterTypes.NO_FORMATTER,
    barPercentage: "90",
    maxBarThickness: "60",
})